import { call, put, takeLatest } from "redux-saga/effects";

import {
  getTokenTransactionsSuccess,
  getTokenTransactionsFailure,
} from "./TokenTransactions.actions";
import { TokenTransactionsService } from "./TokenTransactions.store";

function* getTokenTransactionsSaga(args) {
  try {
    const tokenTransactionsService = new TokenTransactionsService();
    const { data, total, rangeTotal } = yield call(
      tokenTransactionsService.fetchTokenTransactions,
      args
    );
    const { token, dateRange } = args;
    yield put(
      getTokenTransactionsSuccess(data, token, dateRange, total, rangeTotal)
    );
  } catch (error) {
    yield put(getTokenTransactionsFailure(error));
  }
}

export function* tokenTransactionsSagas() {
  const GET_TOKENTRANSACTIONS = "GET_TOKENTRANSACTIONS";
  yield takeLatest(GET_TOKENTRANSACTIONS, getTokenTransactionsSaga);
}
